import { useNavigate } from "react-router-dom";
import { RoutesLink } from "../../../../ApiHelper/RoutesLink";
import PlusIcon from "../../../../components/Icons/PlusIcon";
import { useEffect, useState } from "react";
import EditIcon from "../../../../components/Icons/EditIcon";
import DeleteIcon from "../../../../components/Icons/DeleteIcon";
import { callApi } from "../../../../ApiHelper/ApiHelper";
import { apiUrl } from "../../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import MainHeading from "../../../../components/comman/MainHeading";
import FilterComponent from "../../../../components/comman/FilterComponent";
import CommonTable from "../../../../components/comman/CommonTable";
import ConfirmModal from "../../../../components/comman/ConfirmModal";
import { MainFilterHandler } from "../../../../components/comman/MainFilterHandler";

export default function LeaveSetting() {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);
    const [state, setState] = useState({
        attendanceCount: null,
        LeaveList: [],
    });
    const toggle = () => setModal(!modal);
    const [selectedId, setSelectedId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [pageStates, setPageStates] = useState({
        currentPage: 1,
        pageSize: 10,
        count: 0,
        totalPages: 0,
        tableLoader: false,
        filterData: "",
        month: "",
    });
    const getLeaveSetting = (pageNo) => {
        let options = {
            method: "GET",
        };
        setPageStates((prev) => ({
            ...prev,
            tableLoader: true,
        }));
        const Url = apiUrl.get_leave_setting + "?" + MainFilterHandler(pageStates) + '&all=true';
        callApi(Url, options).then((res) => {
            setPageStates((prev) => ({
                ...prev,
                tableLoader: false,
            }));
            // console.log("res", res);
            if (res?.status === true) {
                const newData = res?.data
                    ?.map((item) => ({
                        ...item,
                        leaveType: item?.type,
                        ApplFrom: moment(item?.applicableFrom).format("MMMM Do YYYY"),
                        TtlLeave: item?.totalLeavePerMonth,
                        TtlLeaveYear: item?.totalLeavePerYear,
                    }));
                setState((pre) => ({
                    ...pre,
                    LeaveList: newData,
                }));
                setPageStates((pre) => ({
                    ...pre,
                    count: res?.data?.pageInfo?.total,
                    totalPages: res?.data?.pageInfo?.totalPages,
                }))
            }
        })
    }

    const TableHeading = [
        { value: "index", label: "SR NO." },
        { value: "leaveType", label: "Leave Type" },
        { value: "ApplFrom", label: "Appl. From" },
        { value: "TtlLeave", label: "Ttl. Leave (Mon)" },
        { value: "TtlLeaveYear", label: "Ttl. Leave (yr)" },
        // { value: "CarryFrwd", label: "Carry Frwd" },
    ];

    useEffect(() => {
        getLeaveSetting();
    }, [pageStates?.month, pageStates.pageSize, pageStates.currentPage]);

    const PageChangeHandler = (PageNo) => {
        // console.log("PageChangeHandler", PageNo);
        if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
            setPageStates((prev) => ({
                ...prev,
                currentPage: PageNo,
            }));
        }
    };

    const handleChangePageSize = (value) => {
        setPageStates((prev) => ({
            ...prev,
            pageSize: value,
            currentPage: 1
        }));
    };

    const ActionHandler = (data) => {
        setSelectedId(data?.id)
        toggle();
    }

    const HandleUpdate = (data) => {
        navigate(RoutesLink?.add_leave_setting, { state: { EditData: data } })
    };

    const HandleDelete = () => {
        let options = {
            method: "GET",
        };
        let API = apiUrl.delete_leave_setting + `?leaveId=${selectedId}`;
        setIsLoading(true);
        callApi(API, options).then((response) => {
            setIsLoading(false);
            if (response?.status === true) {
                toast.success(response?.message);
                toggle();
                getLeaveSetting();
            } else {
                toast.error(response?.message);
                toggle();
            }
        });
    };

    const ActionData = [
        {
            label: "Edit",
            className: "btn btn-link",
            icon: <EditIcon />,
            title: "edit",
            clickHandler: HandleUpdate,
        },
        {
            label: "Delete",
            className: "btn btn-link",
            icon: <DeleteIcon />,
            title: "delete",
            clickHandler: ActionHandler,
        },
    ];


    return (
        <>
            <>
                <div className="content">
                    <MainHeading
                        title={"Leave Settings"}
                        buttonText={"Add Leave Settings"}
                        buttonIcon={<PlusIcon />}
                        buttonLink={RoutesLink?.add_leave_setting}
                    />
                    <div className="card mb-4">
                        <div className="card-body">
                            <FilterComponent />
                            <CommonTable
                                TableHeading={TableHeading}
                                TableData={state?.LeaveList}
                                ActionData={ActionData}
                                currentPage={pageStates?.currentPage}
                                PageChangeHandler={PageChangeHandler}
                                isLoading={pageStates?.tableLoader}
                                totalPages={pageStates?.totalPages}
                                count={pageStates?.count}
                                handleChangePageSize={handleChangePageSize}
                                pageSize={pageStates.pageSize}
                            />
                        </div>
                    </div>
                </div>
            </>
            <ConfirmModal
                modal={modal}
                toggle={toggle}
                submitHandler={HandleDelete}
                isLoading={isLoading}
            />
        </>
    );
}
